const checkoutStateComputedMixin = {
  computed: {
    breadcrumbs() {
      return this.$store.state.checkout.breadcrumbs
    },
    activeBreadcrumbIndex() {
      return this.$store.state.checkout.activeBreadcrumbIndex;
    },
    removePromoCodeUrl() {
      return this.$store.state.cartPage.removePromoCodeUrl;
    },
    voucherResult() {
      return this.$store.state.cartPage.voucherResult;
    }
  }
};

export default checkoutStateComputedMixin;
